import { ChatInterface } from '../components/chat/ChatInterface';
import { ChatErrorBoundary } from '../components/chat/ChatErrorBoundary';

/**
 * Chat page route component.
 * Renders ChatInterface within the protected route layout.
 * Session state resets on unmount (navigating away ends the session,
 * returning starts fresh) per requirement 4.3.
 *
 * ChatErrorBoundary catches initialization failures (e.g., Bedrock unavailable)
 * and displays a service-unavailable message with a retry option per requirement 1.4.
 *
 * Requirements: 1.1, 1.3, 1.4, 4.3
 */
export function ChatPage() {
  return (
    <div className="page chat-page">
      <ChatErrorBoundary>
        <ChatInterface />
      </ChatErrorBoundary>
    </div>
  );
}
